
import { ClientPortalPaymentQrConfig } from "@/models/dossier-configs/client-portal-payment-qr-config";
import AppSelectBankType from "@/components/bank/SelectBankType.vue";
import Vue from "vue";
import { BankService } from "@/services/bank-service";
import { BankType } from "@/models/base";

export default Vue.extend({
	props: {
		settings: {
			type: Object as ()=>ClientPortalPaymentQrConfig,
			required: true
		}
	},
	computed: {
		disabled():boolean {
			return !this.settings.Show || !this.hasValidBanks;
		},
		validBanks():BankType[] {
			return BankService.getTypes().filter(b=>b.Iban);
		},
		hasValidBanks():boolean {
			return this.validBanks.length > 0;
		},
	},
	methods: {
		toggleShow(value:boolean){
			if (!this.hasValidBanks) {
				this.settings.Show = false;
			}
			this.settings.Show = value;
			if (this.settings.Show){
				let validBankIds = this.validBanks.map(b=>b.ID);
				if (validBankIds.indexOf(this.settings.BankID) >-1) {
					return;
				}
				this.settings.BankID = validBankIds[0];
			}
		}
	},
	components: {
		AppSelectBankType
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
